import React, {useState} from "react";
import BarcodeScanner from "./BarcodeScanner";
import {IoMdQrScanner} from "react-icons/io";

interface BarcodeProps {
    readScannedResults: (barcodeText: string) => void;
}

const Barcode = ({readScannedResults}: BarcodeProps) => {
    const [showBarcodeScanner, setShowBarcodeScanner] = useState(false);

    return (
        <div className="file-dropper-container">
            <div className="ocr-enabled-field-field-container">
                <IoMdQrScanner className='file-dropper-camera-icon' onClick={() => setShowBarcodeScanner(prev => !prev)}/>
                {showBarcodeScanner &&
                <BarcodeScanner
                    readScannedResults={readScannedResults}
                />
                }
            </div>
        </div>
    )
}

export default Barcode;
